<template>
    <card-grid-item
        :tab-widget="tabWidget"
        :card-class="['card-grid']"
        :min-w="3"
        :min-h="minHeight"
        :resized="handleResized"
        @tab-widget-settings-click="handleTabWidgetSettingsClick"
    >
        <template v-slot:card-title>
            {{ title }}
        </template>
        <template v-slot:card-body>
            <card-grid
                ref="grid"
                :key="cardGridKey"
                :is-search="false"
                :columnDefs="columnDefs"
                :fetch-callback="fetchCallback"
                :pagination="true"
                :pagination-page-size="limit"
                :cache-block-size="limit"
                :is-auto-width="true"
                :font-size="tabWidget.settings.table_font_size"
            ></card-grid>
        </template>
        <template v-slot:tab-widget-settings-modal>
            <tab-widget-settings-modal-form
                :modal-id="tabWidgetSettingsModalID"
                :update="updateTabWidgetSettings"
                :initial-values="tabWidgetSettingsInitialValues"
                @success-update="handleSuccessTabWidgetSettingsUpdate"
                :withTableFontSize="true"
            ></tab-widget-settings-modal-form>
        </template>
    </card-grid-item>
</template>

<script>
    import API from '../../../../api';
    import CardGrid from '../../../generic/card-grid/card-grid.vue';
    import CardGridItem from '../common/card-grid-item.vue';
    import ActionsCellRenderer from './actions-cell-renderer.vue';
    import {
        COMMUNICATION_ACTION_BOUNCE_GRID_ENDPOINT,
        COMMUNICATION_ACTION_BOUNCE_DELETE_ENDPOINT,
    } from '../../../../endpoints';
    import GuestCellRenderer from '../common/guest-cell-renderer.vue';
    import { getWidgetGridRowsNumber } from '../helpers';
    import { mapGetters } from 'vuex';
    import TabWidgetSettingsModalForm from '../common/tab-widget-settings-modal-form.vue';
    import HeaderComponent from './header-component.vue';
import cardGridItemBaseMixin from '../common/card-grid-item-base-mixin';

    export default {
        name: 'GuestEmailBouncesTableCardGridItem',
        mixins: [cardGridItemBaseMixin],
        components: {
            CardGrid,
            CardGridItem,
            TabWidgetSettingsModalForm,
            agHeaderComponent: HeaderComponent,
            actionsCellRenderer: ActionsCellRenderer,
            guestCellRenderer: GuestCellRenderer,
        },
        computed: {
            ...mapGetters('header', ['userPermissions']),
            fetchCallback() {
                return ({ offset, limit, sort, desc, search }) => {
                    this.offset = offset;
                    this.limit = limit;
                    this.sort = sort;
                    this.desc = desc;
                    this.search = search;
                    return API.get(COMMUNICATION_ACTION_BOUNCE_GRID_ENDPOINT(), {
                        params: {
                            offset,
                            limit,
                            sort,
                            desc,
                            search,
                        },
                    });
                };
            },
            tabWidgetSettingsInitialValues() {
                return {
                    settings: {
                        name: this.tabWidget.settings.name || this.defaultName,
                        table_font_size:
                            this.tabWidget.settings.table_font_size ||
                            this.defaultWidgetFontSize,
                    },
                };
            },
            columnDefs() {
                return [
                    {
                        field: 'id',
                        hide: true,
                    },
                    {
                        field: 'created',
                        headerName: 'Date',
                        type: 'dateTimeColumn',
                        sort: 'desc',
                        minWidth: 180,
                        autoWidthExclude: true,
                    },
                    {
                        field: 'to',
                        headerName: 'To',
                        minWidth: 240,
                        autoWidthExclude: true,
                    },
                    {
                        field: 'communication_action.reservation.user.short_name',
                        headerName: 'Guest',
                        id: 'guest',
                        headerClass: 'guest-name-status-column',
                        cellRenderer: 'guestCellRenderer',
                        cellRendererParams: {
                            getReservation({ data }) {
                                return (
                                    data.communication_action &&
                                    data.communication_action.reservation
                                );
                            },
                        },
                        minWidth: 200,
                        autoWidthExclude: true,
                    },
                    {
                        field: 'communication_action.reservation.id',
                        headerName: 'Invoice ID',
                        cellRenderer: ({ data }) => {
                            const reservation =
                                data &&
                                data.communication_action &&
                                data.communication_action.reservation;
                            if (reservation) {
                                if (
                                    this.userPermissions &&
                                    this.userPermissions.can_view_invoices
                                ) {
                                    return `<a href="/app/reservation/edit/invoice/${reservation.id}">${reservation.id}</a>`;
                                }
                                return `${reservation.id}`;
                            }
                        },
                        minWidth: 100,
                    },
                    {
                        field: 'subject',
                        headerName: 'Subject',
                        // minWidth: 130,
                    },
                    {
                        field: 'category',
                        headerName: 'Error',
                        // minWidth: 130,
                    },
                    {
                        field: '',
                        headerName: '',
                        minWidth: 80,
                        maxWidth: 80,
                        sortable: false,
                        cellRenderer: 'actionsCellRenderer',
                        cellRendererParams: {
                            update: () => {
                                this.$refs.grid.refreshServerSide();
                            },
                        },
                        cellClass: 'arrivals-actions',
                        headerClass: 'd-flex justify-content-center',
                        headerComponent: 'agHeaderComponent',
                        headerComponentParams: {
                            hideColumn: () => this.$refs.grid && this.$refs.grid.$refs.cardGridGrid.getTotalRecords() <= 0,
                            removeAll: async () => {
                                try {
                                    await API.delete(
                                        `${COMMUNICATION_ACTION_BOUNCE_DELETE_ENDPOINT()}bulk-delete/`
                                    );
                                    this.$refs.grid.refreshServerSide();
                                } catch (e) {
                                    this.errorToast({
                                        text: 'Could not delete bounce.',
                                    });
                                }
                            },
                        },
                    },
                ]
            }
        },
        data() {
            return {
                offset: 0,
                limit: getWidgetGridRowsNumber({ tabWidget: this.tabWidget }),
                sort: 'id',
                desc: false,
                search: '',
            };
        },
        methods: {
            handleResized() {
                this.limit = getWidgetGridRowsNumber({ tabWidget: this.tabWidget });
                this.cardGridKey += 1;
            },
        },
    };
</script>
